import { render, staticRenderFns } from "./ModalPedido.vue?vue&type=template&id=4fa045a6"
import script from "./ModalPedido.vue?vue&type=script&lang=js"
export * from "./ModalPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports